


































































































































































import Vue from 'vue';
import { HubModal } from '@/components/HubComponents';

export default Vue.extend({
  name: 'ModalTechicalInfo' as string,

  components: { HubModal },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isModalOpen: this.value,
      selectedTab: 'Facebook',
      tabs: ['Facebook', 'Youtube', /* 'Twitter', */ /* 'Twitch TV', */ 'customized'/* , 'Instagram' */],
    };
  },

  watch: {
    isModalOpen(): void {
      this.$emit('input', this.isModalOpen);
    },
    value(): void {
      this.isModalOpen = this.value;
    },
  },
});
